/* ==========================================================================
   Hotpot Box Configurator — Logica (volledige, samengevoegde versie)
   Bevat: box/losse-hotpot-keuze (Stap 1), personen (Stap 2), smaken +
   schaaltjeskleur + boekformaat (Stap 3), extra's incl. variant-keuze
   (Stap 4), overzicht met meerdere Experiences + bewerken (Stap 5),
   winkelwagen-badge, deep-link naar #extras, behoud van voortgang via
   sessionStorage, en volledig vertaalbare teksten via window.hotpotConfiguratorData.strings.

   Bugfixes t.o.v. vorige versie:
   - resetStateAndUI verwees naar een niet-bestaande "payload"-variabele
     (crashte de app bij "Nog een Experience toevoegen").
   - buildConfigCardHtml bouwde de detail-regels niet meer op (afgeronde
     Experiences toonden geen Box/samenstelling/extra's meer in Stap 5).
   - Ongebruikte attemptConfirmFlavors-functie verwijderd.
   ========================================================================== */

(function () {
  'use strict';

  var TOTAL_STEPS = 5;

  document.addEventListener('DOMContentLoaded', initAllConfigurators);

  function initAllConfigurators() {
    var roots = document.querySelectorAll('.hotpot-configurator');
    roots.forEach(function (root) {
      new HotpotConfigurator(root);
    });
  }

  function scrollToStep(stepEl) {
    if (!stepEl) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        stepEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  var DEFAULT_STRINGS = {
    step3: { chosenCount: '{{ count }} / {{ required }}' },
    step5: {
      box: 'Box',
      boxStandalone: 'Standalone Hotpot',
      boxNoBox: 'Individual products',
      chosenComposition: 'Chosen composition',
      soupBase: 'Soup base',
      dipSauce: 'Dipping sauce',
      plateColorLabel: 'Bowls',
      bookLabel: 'Book',
      extraAdditions: 'Extra additions',
      extraSoupLabel: 'Extra soup base',
      extraSauceLabel: 'Extra dipping sauce',
      edit: 'Edit',
      subtotal: 'Subtotal',
      removeAria: 'Remove',
      total: 'Total',
      experienceNumber: 'Experience {{ number }}',
      currentSuffix: ' (current)',
      productTitleFallback: 'Hotpot Experience',
      perUnit: 'each'
    },
    summaryBar: {
      adding: 'Adding...',
      added: 'Added ✓',
      redirecting: 'Redirecting...',
      selectFirst: 'Choose something first',
      failed: 'Failed, please try again',
      addToCart: 'Add to cart'
    }
  };

  function mergeStrings(base, override) {
    var result = {};
    Object.keys(base).forEach(function (key) {
      if (override && typeof override[key] === 'object' && override[key] !== null) {
        result[key] = mergeStrings(base[key], override[key]);
      } else if (override && override[key] !== undefined) {
        result[key] = override[key];
      } else {
        result[key] = base[key];
      }
    });
    return result;
  }

  function HotpotConfigurator(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId;
    this.data = (window.hotpotConfiguratorData && window.hotpotConfiguratorData[this.sectionId]) || { variants: [] };
    this.strings = mergeStrings(DEFAULT_STRINGS, this.data.strings || {});

    this.completedConfigs = [];
    this.state = this.createEmptyConfigState();

    this.boxStep = root.querySelector('[data-hotpot-step="box"]');
    this.personsStep = root.querySelector('[data-hotpot-step="persons"]');
    this.flavorsStep = root.querySelector('[data-hotpot-step="flavors"]');
    this.extrasStep = root.querySelector('[data-hotpot-step="extras"]');
    this.summaryStep = root.querySelector('[data-hotpot-step="summary"]');

    this.summaryBar = root.querySelector('[data-hotpot-summary-bar]');
    this.totalPriceEl = root.querySelector('[data-hotpot-total-price]');
    this.comparePriceEl = root.querySelector('[data-hotpot-compare-price]');
    this.addButton = root.querySelector('[data-hotpot-add-to-cart]');
    this.checkoutButton = root.querySelector('[data-hotpot-checkout]');
    this.cartBadgeEl = root.querySelector('[data-hotpot-cart-badge]');
    this.cartTotalPriceEl = root.querySelector('[data-hotpot-cart-total-price]');

    this.summaryListEl = root.querySelector('[data-hotpot-summary-list]');
    this.summaryCurrentEl = root.querySelector('[data-hotpot-summary-current]');
    this.grandTotalEl = root.querySelector('[data-hotpot-grand-total]');
    this.grandCompareEl = root.querySelector('[data-hotpot-grand-compare]');

    this.progressBarEl = root.querySelector('.hotpot-progress');
    this.progressFill = root.querySelector('[data-hotpot-progress-fill]');
    this.progressSteps = root.querySelectorAll('[data-hotpot-progress-step]');

    this.bindEvents();
    this.initSlider();
    this.initExtrasSlider();
    this.updateScrollOffset();

    var self = this;
    window.addEventListener('resize', function () {
      self.updateScrollOffset();
    });

    this.updateCartBadge();
    this.loadStateFromStorage();
    this.handleDeepLinkHash();
    this.initStickyProgressFallback();
  }

  HotpotConfigurator.prototype.initStickyProgressFallback = function () {
    var self = this;
    if (!this.progressBarEl || !('IntersectionObserver' in window)) return;

    var sentinel = document.createElement('div');
    sentinel.style.height = '1px';
    this.progressBarEl.parentNode.insertBefore(sentinel, this.progressBarEl);

    var spacer = document.createElement('div');
    spacer.className = 'hotpot-progress-spacer';
    spacer.hidden = true;
    this.progressBarEl.parentNode.insertBefore(spacer, this.progressBarEl.nextSibling);

    var fadeDistance = 100;
    var pinStartScroll = 0;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var isPinned = !entry.isIntersecting;

        if (isPinned) {
          spacer.style.height = self.progressBarEl.offsetHeight + 'px';
          spacer.hidden = false;
          self.progressBarEl.classList.add('is-pinned');

          pinStartScroll = window.scrollY;
          self.progressBarEl.style.opacity = '0';

          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              self.progressBarEl.classList.add('is-visible');
            });
          });
        } else {
          self.progressBarEl.classList.remove('is-pinned', 'is-visible');
          spacer.hidden = true;
          self.progressBarEl.style.opacity = '';
        }
      });
    }, { threshold: 0 });

    window.addEventListener('scroll', function () {
      if (!self.progressBarEl.classList.contains('is-pinned')) return;

      var distanceScrolled = window.scrollY - pinStartScroll;
      var opacity = Math.min(Math.max(distanceScrolled / fadeDistance, 0), 1);

      self.progressBarEl.style.opacity = opacity;
    });

    observer.observe(sentinel);
  };

  HotpotConfigurator.prototype.createEmptyConfigState = function () {
    return {
      baseVariantId: null,
      persons: null,
      priceCents: 0,
      comparePriceCents: 0,
      soupSelections: {},
      sauceSelections: {},
      plateColor: null,
      bookFormat: null,
      extraSimple: {},
      extraSoupSelections: {},
      extraSauceSelections: {},
      skippedExtras: false
    };
  };

  HotpotConfigurator.prototype.handleDeepLinkHash = function () {
    if (window.location.hash !== '#extras') return;

    if (this.extrasStep && this.extrasStep.hidden) {
      this.selectLooseProducts();
    } else if (this.extrasStep) {
      scrollToStep(this.extrasStep);
    }
  };

  HotpotConfigurator.prototype.updateScrollOffset = function () {
    var headerEl = document.querySelector(
      'sticky-header, .shopify-section-header, #shopify-section-header, .site-header, header.header, .header-wrapper'
    );
    var headerHeight = headerEl ? headerEl.offsetHeight : 0;
    var progressHeight = this.progressBarEl ? this.progressBarEl.offsetHeight : 0;
    var gap = 24;

    this.root.style.setProperty('--hotpot-header-offset', headerHeight + 'px');
    this.root.style.setProperty('--hotpot-scroll-offset', (headerHeight + progressHeight + gap) + 'px');
  };

  HotpotConfigurator.prototype.bindEvents = function () {
    var self = this;

    var selectBoxButton = this.root.querySelector('[data-hotpot-select-box]');
    if (selectBoxButton) {
      selectBoxButton.addEventListener('click', function () {
        self.selectBox(selectBoxButton);
      });
    }

    var selectLooseButton = this.root.querySelector('[data-hotpot-select-loose]');
    if (selectLooseButton) {
      selectLooseButton.addEventListener('click', function () {
        self.selectLooseProducts();
      });
    }

    var personButtons = this.root.querySelectorAll('[data-hotpot-select-persons]');
    personButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.selectPersons(button);
      });
    });

    var skipButtons = this.root.querySelectorAll('[data-hotpot-skip-persons]');
    skipButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.skipPersons(button);
      });
    });

    var flavorSteppers = this.root.querySelectorAll('[data-hotpot-flavor-stepper]');
    flavorSteppers.forEach(function (stepperEl) {
      var increaseBtn = stepperEl.querySelector('[data-hotpot-flavor-increase]');
      var decreaseBtn = stepperEl.querySelector('[data-hotpot-flavor-decrease]');
      if (increaseBtn) increaseBtn.addEventListener('click', function () { self.changeFlavorCount(stepperEl, 1); });
      if (decreaseBtn) decreaseBtn.addEventListener('click', function () { self.changeFlavorCount(stepperEl, -1); });
    });

    var singleChoiceButtons = this.root.querySelectorAll('[data-hotpot-single-choice-option]');
    singleChoiceButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.selectSingleChoice(button);
      });
    });

    var flavorsContinueButton = this.root.querySelector('[data-hotpot-flavors-continue]');
    if (flavorsContinueButton) {
      flavorsContinueButton.addEventListener('click', function () {
        self.confirmFlavors();
      });
    }

    var extraSimpleSteppers = this.root.querySelectorAll('[data-hotpot-extra-stepper]');
    extraSimpleSteppers.forEach(function (stepperEl) {
      var increaseBtn = stepperEl.querySelector('[data-hotpot-extra-increase]');
      var decreaseBtn = stepperEl.querySelector('[data-hotpot-extra-decrease]');
      if (increaseBtn) increaseBtn.addEventListener('click', function () { self.changeExtraSimpleCount(stepperEl, 1); });
      if (decreaseBtn) decreaseBtn.addEventListener('click', function () { self.changeExtraSimpleCount(stepperEl, -1); });
    });

    var extraVariantSelects = this.root.querySelectorAll('[data-hotpot-extra-variant-select]');
    extraVariantSelects.forEach(function (selectEl) {
      selectEl.addEventListener('change', function () {
        self.changeExtraVariant(selectEl);
      });
    });

    var extraFlavorSteppers = this.root.querySelectorAll('[data-hotpot-extra-flavor-stepper]');
    extraFlavorSteppers.forEach(function (stepperEl) {
      var increaseBtn = stepperEl.querySelector('[data-hotpot-extra-flavor-increase]');
      var decreaseBtn = stepperEl.querySelector('[data-hotpot-extra-flavor-decrease]');
      if (increaseBtn) increaseBtn.addEventListener('click', function () { self.changeExtraFlavorCount(stepperEl, 1); });
      if (decreaseBtn) decreaseBtn.addEventListener('click', function () { self.changeExtraFlavorCount(stepperEl, -1); });
    });

    var extrasContinueButton = this.root.querySelector('[data-hotpot-extras-continue]');
    if (extrasContinueButton) {
      extrasContinueButton.addEventListener('click', function () {
        self.confirmExtras();
      });
    }

    var skipToSummaryButton = this.root.querySelector('[data-hotpot-skip-to-summary]');
    if (skipToSummaryButton) {
      skipToSummaryButton.addEventListener('click', function () {
        self.confirmExtras();
      });
    }

    var addAnotherButton = this.root.querySelector('[data-hotpot-add-another]');
    if (addAnotherButton) {
      addAnotherButton.addEventListener('click', function () {
        self.addAnotherExperience();
      });
    }

    var summaryAddToCartButton = this.root.querySelector('[data-hotpot-summary-add-to-cart]');
    if (summaryAddToCartButton) {
      summaryAddToCartButton.addEventListener('click', function () {
        self.addToCart(false);
      });
    }

    if (this.summaryListEl) {
      this.summaryListEl.addEventListener('click', function (event) {
        var removeBtn = event.target.closest('[data-remove-config]');
        var editBtn = event.target.closest('[data-edit-config]');
        if (removeBtn) {
          self.removeCompletedConfig(parseInt(removeBtn.dataset.removeConfig, 10));
        } else if (editBtn) {
          self.editCompletedConfig(parseInt(editBtn.dataset.editConfig, 10));
        }
      });
    }

    if (this.summaryCurrentEl) {
      this.summaryCurrentEl.addEventListener('click', function (event) {
        self.handleSummaryCurrentClick(event);
      });
    }

    if (this.addButton) {
      this.addButton.addEventListener('click', function () {
        self.addToCart(false);
      });
    }

    if (this.checkoutButton) {
      this.checkoutButton.addEventListener('click', function () {
        self.addToCart(true);
      });
    }
  };

  /* --- Stap 1: box selecteren --- */

  HotpotConfigurator.prototype.selectBox = function (button) {
    var frame = button.closest('.hotpot-choice-frame');
    if (frame) {
      var allFrames = this.root.querySelectorAll('.hotpot-choice-frame');
      allFrames.forEach(function (f) { f.classList.remove('is-selected'); });
      frame.classList.add('is-selected');
    }

    this.state.priceCents = parseInt(this.data.priceMinCents, 10) || 0;
    this.state.comparePriceCents = parseInt(this.data.compareAtPriceMinCents, 10) || 0;

    this.updateSummary();

    if (this.personsStep) {
      this.personsStep.hidden = false;
      scrollToStep(this.personsStep);
    }

    this.setProgress(1, true);
  };

  HotpotConfigurator.prototype.selectLooseProducts = function () {
    this.state.baseVariantId = null;
    this.state.persons = null;
    this.state.priceCents = 0;
    this.state.comparePriceCents = 0;
    this.state.skippedExtras = true;

    if (this.personsStep) this.personsStep.hidden = true;
    if (this.flavorsStep) this.flavorsStep.hidden = true;
    if (this.summaryStep) this.summaryStep.hidden = true;

    if (this.extrasStep) {
      this.extrasStep.hidden = false;
      scrollToStep(this.extrasStep);
    }

    this.updateSummary();
    this.setProgress(3, true);
  };

  /* --- Stap 1: foto-slider --- */

  HotpotConfigurator.prototype.initSlider = function () {
    var slider = this.root.querySelector('[data-hotpot-slider]');
    if (!slider) return;

    var slides = slider.querySelectorAll('[data-hotpot-slide]');
    var dots = slider.querySelectorAll('[data-hotpot-slider-dot]');
    var prevBtn = slider.querySelector('[data-hotpot-slider-prev]');
    var nextBtn = slider.querySelector('[data-hotpot-slider-next]');
    var currentIndex = 0;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      currentIndex = index;
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === currentIndex); });
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === currentIndex); });
    }

    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); goTo(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); goTo(currentIndex + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) { e.stopPropagation(); goTo(i); });
    });
  };

  HotpotConfigurator.prototype.initExtrasSlider = function () {
    var slider = this.root.querySelector('[data-hotpot-extras-slider]');
    if (!slider) return;

    var track = slider.querySelector('[data-hotpot-extras-track]');
    var prevBtn = slider.querySelector('[data-hotpot-extras-prev]');
    var nextBtn = slider.querySelector('[data-hotpot-extras-next]');
    if (!track) return;

    function scrollByCard(direction) {
      var card = track.querySelector('.hotpot-extra-card');
      var cardWidth = card ? card.getBoundingClientRect().width + 14 : 200;
      track.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
  };

  /* --- Stap 2: personen kiezen --- */

  HotpotConfigurator.prototype.selectPersons = function (button) {
    var allButtons = this.root.querySelectorAll('[data-hotpot-select-persons]');
    allButtons.forEach(function (btn) { btn.classList.remove('is-selected'); });
    button.classList.add('is-selected');

    this.state.baseVariantId = button.dataset.variantId;
    this.state.persons = button.dataset.variantTitle;
    this.state.priceCents = parseInt(button.dataset.variantPrice, 10) || 0;
    this.state.comparePriceCents = parseInt(button.dataset.variantComparePrice, 10) || 0;
    this.state.skippedExtras = false;

    var soupCount = parseInt(button.dataset.soupCount, 10) || 0;
    var sauceCount = parseInt(button.dataset.sauceCount, 10) || 0;

    this.updateSummary();
    this.setProgress(2, true);

    if (this.flavorsStep) {
      this.flavorsStep.hidden = false;
      scrollToStep(this.flavorsStep);
    }
    if (this.extrasStep) this.extrasStep.hidden = true;
    if (this.summaryStep) this.summaryStep.hidden = true;

    this.setupFlavorGroup('soup', soupCount);
    this.setupFlavorGroup('sauce', sauceCount);
  };

  HotpotConfigurator.prototype.skipPersons = function (button) {
    var allButtons = this.root.querySelectorAll('[data-hotpot-select-persons]');
    allButtons.forEach(function (btn) { btn.classList.remove('is-selected'); });

    var frame = button.closest('.hotpot-choice-frame');
    if (frame) {
      var allFrames = this.root.querySelectorAll('.hotpot-choice-frame');
      allFrames.forEach(function (f) { f.classList.remove('is-selected'); });
      frame.classList.add('is-selected');
    }

    this.state.baseVariantId = button.dataset.variantId;
    this.state.persons = null;
    this.state.priceCents = parseInt(button.dataset.variantPrice, 10) || 0;
    this.state.comparePriceCents = parseInt(button.dataset.variantComparePrice, 10) || 0;
    this.state.skippedExtras = true;

    this.updateSummary();

    if (this.flavorsStep) this.flavorsStep.hidden = true;
    if (this.summaryStep) this.summaryStep.hidden = true;

    if (this.extrasStep) {
      this.extrasStep.hidden = false;
      scrollToStep(this.extrasStep);
    }

    this.setProgress(3, true);
  };

  /* --- Stap 3: smaken (geen auto-invulling) --- */

  HotpotConfigurator.prototype.setupFlavorGroup = function (group, requiredCount) {
    var groupEl = this.root.querySelector('[data-hotpot-flavor-group="' + group + '"]');
    if (!groupEl) return;

    groupEl.dataset.requiredCount = requiredCount;

    var selections = group === 'soup' ? this.state.soupSelections : this.state.sauceSelections;
    Object.keys(selections).forEach(function (key) { delete selections[key]; });

    var steppers = groupEl.querySelectorAll('[data-hotpot-flavor-stepper]');
    steppers.forEach(function (stepperEl) {
      var countEl = stepperEl.querySelector('[data-hotpot-flavor-count]');
      if (countEl) countEl.textContent = '0';
      stepperEl.classList.remove('has-selection');
    });

    this.updateFlavorGroupCounter(group);
  };

  HotpotConfigurator.prototype.changeFlavorCount = function (stepperEl, delta) {
    var group = stepperEl.dataset.flavorGroup;
    var name = stepperEl.dataset.flavorName;
    var groupEl = this.root.querySelector('[data-hotpot-flavor-group="' + group + '"]');
    if (!groupEl) return;

    var required = parseInt(groupEl.dataset.requiredCount, 10) || 0;
    var selections = group === 'soup' ? this.state.soupSelections : this.state.sauceSelections;
    var currentTotal = this.sumSelections(selections);
    var currentValue = selections[name] || 0;

    if (delta > 0) {
      if (currentTotal >= required) {
        var madeRoom = this.stealFromOtherFlavor(groupEl, selections, name);
        if (!madeRoom) return;
      }
      selections[name] = currentValue + 1;
    } else {
      if (currentValue <= 0) return;
      selections[name] = currentValue - 1;
    }

    var countEl = stepperEl.querySelector('[data-hotpot-flavor-count]');
    if (countEl) countEl.textContent = String(selections[name]);
    stepperEl.classList.toggle('has-selection', selections[name] > 0);

    this.updateFlavorGroupCounter(group);
    this.saveStateToStorage();
  };

  HotpotConfigurator.prototype.stealFromOtherFlavor = function (groupEl, selections, excludeName) {
    var candidateName = null;
    var candidateCount = 0;

    Object.keys(selections).forEach(function (name) {
      if (name === excludeName) return;
      if (selections[name] > candidateCount) {
        candidateCount = selections[name];
        candidateName = name;
      }
    });

    if (!candidateName || candidateCount <= 0) return false;

    selections[candidateName] = candidateCount - 1;

    var otherStepperEl = groupEl.querySelector('[data-hotpot-flavor-stepper][data-flavor-name="' + candidateName + '"]');
    if (otherStepperEl) {
      var otherCountEl = otherStepperEl.querySelector('[data-hotpot-flavor-count]');
      if (otherCountEl) otherCountEl.textContent = String(selections[candidateName]);
      otherStepperEl.classList.toggle('has-selection', selections[candidateName] > 0);
    }

    return true;
  };

  HotpotConfigurator.prototype.sumSelections = function (selections) {
    return Object.keys(selections).reduce(function (sum, key) { return sum + selections[key]; }, 0);
  };

  HotpotConfigurator.prototype.updateFlavorGroupCounter = function (group) {
    var groupEl = this.root.querySelector('[data-hotpot-flavor-group="' + group + '"]');
    if (!groupEl) return;

    var required = parseInt(groupEl.dataset.requiredCount, 10) || 0;
    var selections = group === 'soup' ? this.state.soupSelections : this.state.sauceSelections;
    var total = this.sumSelections(selections);

    var counterEl = groupEl.querySelector('[data-hotpot-flavor-counter]');
    if (counterEl) {
      var text = this.strings.step3.chosenCount
        .replace('{{ count }}', total)
        .replace('{{ required }}', required);
      counterEl.textContent = text;
      counterEl.classList.toggle('is-complete', total === required && required > 0);
    }
  };

  /* --- Stap 3: schaaltjeskleur / boekformaat --- */

  HotpotConfigurator.prototype.selectSingleChoice = function (button) {
    var groupEl = button.closest('[data-hotpot-single-choice-group]');
    if (!groupEl) return;

    var groupName = groupEl.dataset.hotpotSingleChoiceGroup;
    var value = button.dataset.value;

    var buttons = groupEl.querySelectorAll('[data-hotpot-single-choice-option]');
    buttons.forEach(function (btn) { btn.classList.remove('is-selected'); });
    button.classList.add('is-selected');

    this.state[groupName] = value;
    this.saveStateToStorage();
  };

  HotpotConfigurator.prototype.confirmFlavors = function () {
    this.setProgress(3, true);
    if (this.extrasStep) {
      this.extrasStep.hidden = false;
      scrollToStep(this.extrasStep);
    }
    this.saveStateToStorage();
  };

  /* --- Stap 4: gewone extra's (met eventuele variant-keuze) --- */

  HotpotConfigurator.prototype.changeExtraSimpleCount = function (stepperEl, delta) {
    var key = stepperEl.dataset.extraKey;
    var priceCents = parseInt(stepperEl.dataset.priceCents, 10) || 0;
    var comparePriceCents = parseInt(stepperEl.dataset.comparePriceCents, 10) || 0;
    var label = stepperEl.dataset.extraLabel;

    if (!this.state.extraSimple[key]) {
      this.state.extraSimple[key] = { qty: 0, priceCents: priceCents, comparePriceCents: comparePriceCents, label: label };
    }

    var current = this.state.extraSimple[key].qty;
    if (delta > 0) {
      this.state.extraSimple[key].qty = current + 1;
    } else if (current > 0) {
      this.state.extraSimple[key].qty = current - 1;
    }

    var countEl = stepperEl.querySelector('[data-hotpot-extra-count]');
    if (countEl) countEl.textContent = String(this.state.extraSimple[key].qty);
    stepperEl.classList.toggle('has-selection', this.state.extraSimple[key].qty > 0);

    this.updateSummary();
  };

  HotpotConfigurator.prototype.buildPriceHtml = function (priceCents, comparePriceCents) {
    var compareHtml = comparePriceCents > priceCents
      ? '<span class="hotpot-price-compare">' + this.formatMoney(comparePriceCents) + '</span>'
      : '';
    return compareHtml + '<span class="hotpot-price-actual">' + this.formatMoney(priceCents) + '</span>';
  };

  HotpotConfigurator.prototype.changeExtraVariant = function (selectEl) {
    var stepperEl = selectEl.closest('[data-hotpot-extra-stepper]');
    if (!stepperEl) return;

    var option = selectEl.options[selectEl.selectedIndex];
    var newKey = option.value;
    var priceCents = parseInt(option.dataset.priceCents, 10) || 0;
    var comparePriceCents = parseInt(option.dataset.comparePriceCents, 10) || 0;
    var imageUrl = option.dataset.image;

    stepperEl.dataset.extraKey = newKey;
    stepperEl.dataset.priceCents = priceCents;
    stepperEl.dataset.comparePriceCents = comparePriceCents;

    var priceDisplayEl = stepperEl.querySelector('[data-hotpot-extra-price-display]');
    if (priceDisplayEl) priceDisplayEl.innerHTML = this.buildPriceHtml(priceCents, comparePriceCents);

    if (imageUrl) {
      var imageEl = stepperEl.querySelector('.hotpot-extra-card__image-wrapper img');
      if (imageEl) imageEl.src = imageUrl;
    }

    var qty = (this.state.extraSimple[newKey] && this.state.extraSimple[newKey].qty) || 0;
    var countEl = stepperEl.querySelector('[data-hotpot-extra-count]');
    if (countEl) countEl.textContent = String(qty);
    stepperEl.classList.toggle('has-selection', qty > 0);

    this.updateSummary();
  };

  HotpotConfigurator.prototype.changeExtraFlavorCount = function (stepperEl, delta) {
    var group = stepperEl.dataset.extraGroup;
    var name = stepperEl.dataset.flavorName;
    var selections = group === 'soup' ? this.state.extraSoupSelections : this.state.extraSauceSelections;

    var current = selections[name] || 0;
    if (delta > 0) {
      selections[name] = current + 1;
    } else if (current > 0) {
      selections[name] = current - 1;
    }

    var countEl = stepperEl.querySelector('[data-hotpot-extra-flavor-count]');
    if (countEl) countEl.textContent = String(selections[name]);
    stepperEl.classList.toggle('has-selection', selections[name] > 0);

    this.updateSummary();
  };

  HotpotConfigurator.prototype.confirmExtras = function () {
    this.setProgress(4, true);
    if (this.summaryStep) {
      this.summaryStep.hidden = false;
      this.renderSummary();
      scrollToStep(this.summaryStep);
    }
    this.saveStateToStorage();
  };

  /* --- Stap 5: meerdere Experiences --- */

  HotpotConfigurator.prototype.addAnotherExperience = function () {
    if (!this.state.baseVariantId && !this.configHasExtras(this.state)) return;

    this.completedConfigs.push(JSON.parse(JSON.stringify(this.state)));
    this.resetStateAndUI();

    this.renderSummary();
    this.updateSummary();
    this.setProgress(1, true);

    if (this.personsStep) {
      this.personsStep.hidden = false;
      scrollToStep(this.personsStep);
    }
  };

  HotpotConfigurator.prototype.removeCompletedConfig = function (index) {
    this.completedConfigs.splice(index, 1);
    this.renderSummary();
    this.updateSummary();
  };

  HotpotConfigurator.prototype.editCompletedConfig = function (index) {
    var config = this.completedConfigs.splice(index, 1)[0];
    if (!config) return;

    this.state = config;

    var personButton = this.state.baseVariantId
      ? this.root.querySelector('[data-hotpot-select-persons][data-variant-id="' + this.state.baseVariantId + '"]')
      : null;

    if (personButton) {
      var soupCount = parseInt(personButton.dataset.soupCount, 10) || 0;
      var sauceCount = parseInt(personButton.dataset.sauceCount, 10) || 0;
      var soupGroupEl = this.root.querySelector('[data-hotpot-flavor-group="soup"]');
      var sauceGroupEl = this.root.querySelector('[data-hotpot-flavor-group="sauce"]');
      if (soupGroupEl) soupGroupEl.dataset.requiredCount = soupCount;
      if (sauceGroupEl) sauceGroupEl.dataset.requiredCount = sauceCount;
    }

    if (this.personsStep) this.personsStep.hidden = false;
    if (this.flavorsStep) this.flavorsStep.hidden = !this.state.baseVariantId;
    if (this.extrasStep) this.extrasStep.hidden = false;
    if (this.summaryStep) this.summaryStep.hidden = true;

    this.restoreStateToUI();
    this.updateFlavorGroupCounter('soup');
    this.updateFlavorGroupCounter('sauce');

    this.renderSummary();
    this.updateSummary();
    this.setProgress(2, false);

    scrollToStep(this.personsStep || this.extrasStep);
  };

  HotpotConfigurator.prototype.restoreStateToUI = function () {
    var self = this;

    var personButtons = this.root.querySelectorAll('[data-hotpot-select-persons]');
    personButtons.forEach(function (btn) {
      btn.classList.toggle('is-selected', btn.dataset.variantId === self.state.baseVariantId);
    });

    ['soup', 'sauce'].forEach(function (group) {
      var groupEl = self.root.querySelector('[data-hotpot-flavor-group="' + group + '"]');
      if (!groupEl) return;
      var selections = group === 'soup' ? self.state.soupSelections : self.state.sauceSelections;
      var steppers = groupEl.querySelectorAll('[data-hotpot-flavor-stepper]');
      steppers.forEach(function (stepperEl) {
        var name = stepperEl.dataset.flavorName;
        var qty = selections[name] || 0;
        var countEl = stepperEl.querySelector('[data-hotpot-flavor-count]');
        if (countEl) countEl.textContent = String(qty);
        stepperEl.classList.toggle('has-selection', qty > 0);
      });
    });

    var singleChoiceGroups = this.root.querySelectorAll('[data-hotpot-single-choice-group]');
    singleChoiceGroups.forEach(function (groupEl) {
      var groupName = groupEl.dataset.hotpotSingleChoiceGroup;
      var value = self.state[groupName];
      var options = groupEl.querySelectorAll('[data-hotpot-single-choice-option]');
      options.forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.dataset.value === value);
      });
    });

    var extraSimpleSteppers = this.root.querySelectorAll('[data-hotpot-extra-stepper]');
    extraSimpleSteppers.forEach(function (stepperEl) {
      var key = stepperEl.dataset.extraKey;
      var qty = (self.state.extraSimple[key] && self.state.extraSimple[key].qty) || 0;
      var countEl = stepperEl.querySelector('[data-hotpot-extra-count]');
      if (countEl) countEl.textContent = String(qty);
      stepperEl.classList.toggle('has-selection', qty > 0);
    });

    var extraFlavorSteppers = this.root.querySelectorAll('[data-hotpot-extra-flavor-stepper]');
    extraFlavorSteppers.forEach(function (stepperEl) {
      var group = stepperEl.dataset.extraGroup;
      var name = stepperEl.dataset.flavorName;
      var selections = group === 'soup' ? self.state.extraSoupSelections : self.state.extraSauceSelections;
      var qty = selections[name] || 0;
      var countEl = stepperEl.querySelector('[data-hotpot-extra-flavor-count]');
      if (countEl) countEl.textContent = String(qty);
      stepperEl.classList.toggle('has-selection', qty > 0);
    });
  };

  /* Reset alleen de "nieuwe selectie", stap/scrollpositie blijft ongewijzigd. */
  HotpotConfigurator.prototype.softResetSelection = function () {
    this.completedConfigs = [];
    this.state = this.createEmptyConfigState();

    var personButtons = this.root.querySelectorAll('[data-hotpot-select-persons]');
    personButtons.forEach(function (btn) { btn.classList.remove('is-selected'); });

    var allFrames = this.root.querySelectorAll('.hotpot-choice-frame');
    allFrames.forEach(function (f) { f.classList.remove('is-selected'); });

    this.setupFlavorGroup('soup', 0);
    this.setupFlavorGroup('sauce', 0);

    var singleChoiceButtons = this.root.querySelectorAll('[data-hotpot-single-choice-option]');
    singleChoiceButtons.forEach(function (btn) { btn.classList.remove('is-selected'); });

    var extraSimpleSteppers = this.root.querySelectorAll('[data-hotpot-extra-stepper]');
    extraSimpleSteppers.forEach(function (stepperEl) {
      var countEl = stepperEl.querySelector('[data-hotpot-extra-count]');
      if (countEl) countEl.textContent = '0';
      stepperEl.classList.remove('has-selection');
    });

    var extraFlavorSteppers = this.root.querySelectorAll('[data-hotpot-extra-flavor-stepper]');
    extraFlavorSteppers.forEach(function (stepperEl) {
      var countEl = stepperEl.querySelector('[data-hotpot-extra-flavor-count]');
      if (countEl) countEl.textContent = '0';
      stepperEl.classList.remove('has-selection');
    });

    this.renderSummary();
    this.updateSummary();
    this.clearStorageState();
  };

  /* Volledige reset (o.a. gebruikt bij "Nog een Experience toevoegen") —
     verbergt alle stappen weer behalve Stap 1. BUGFIX: verwees voorheen naar
     een niet-bestaande "payload"-variabele, dat gaf een JS-fout. */
  HotpotConfigurator.prototype.resetStateAndUI = function () {
    this.state = this.createEmptyConfigState();

    var personButtons = this.root.querySelectorAll('[data-hotpot-select-persons]');
    personButtons.forEach(function (btn) { btn.classList.remove('is-selected'); });

    var allFrames = this.root.querySelectorAll('.hotpot-choice-frame');
    allFrames.forEach(function (f) { f.classList.remove('is-selected'); });

    this.setupFlavorGroup('soup', 0);
    this.setupFlavorGroup('sauce', 0);

    var singleChoiceButtons = this.root.querySelectorAll('[data-hotpot-single-choice-option]');
    singleChoiceButtons.forEach(function (btn) { btn.classList.remove('is-selected'); });

    var extraSimpleSteppers = this.root.querySelectorAll('[data-hotpot-extra-stepper]');
    extraSimpleSteppers.forEach(function (stepperEl) {
      var countEl = stepperEl.querySelector('[data-hotpot-extra-count]');
      if (countEl) countEl.textContent = '0';
      stepperEl.classList.remove('has-selection');
    });

    var extraFlavorSteppers = this.root.querySelectorAll('[data-hotpot-extra-flavor-stepper]');
    extraFlavorSteppers.forEach(function (stepperEl) {
      var countEl = stepperEl.querySelector('[data-hotpot-extra-flavor-count]');
      if (countEl) countEl.textContent = '0';
      stepperEl.classList.remove('has-selection');
    });

    if (this.personsStep) this.personsStep.hidden = true;
    if (this.flavorsStep) this.flavorsStep.hidden = true;
    if (this.extrasStep) this.extrasStep.hidden = true;
    if (this.summaryStep) this.summaryStep.hidden = true;
  };

  /* --- Stap 5: bewerken van de HUIDIGE (nog niet toegevoegde) configuratie --- */

  HotpotConfigurator.prototype.handleSummaryCurrentClick = function (event) {
    var removeSimpleBtn = event.target.closest('[data-remove-simple]');
    var incSimpleBtn = event.target.closest('[data-inc-simple]');
    var decSimpleBtn = event.target.closest('[data-dec-simple]');
    var removeFlavorBtn = event.target.closest('[data-remove-flavor]');
    var editBoxBtn = event.target.closest('[data-edit-current-box]');
    var editFlavorsBtn = event.target.closest('[data-edit-flavors]');

    if (editBoxBtn) {
      if (this.personsStep) {
        this.personsStep.hidden = false;
        scrollToStep(this.personsStep);
      }
      this.setProgress(2, false);
      this.saveStateToStorage();
      return;
    }

    if (editFlavorsBtn) {
      if (this.flavorsStep) {
        this.flavorsStep.hidden = false;
        scrollToStep(this.flavorsStep);
      }
      this.setProgress(3, false);
      this.saveStateToStorage();
      return;
    }

    if (removeSimpleBtn) {
      delete this.state.extraSimple[removeSimpleBtn.dataset.removeSimple];
      this.syncExtraSimpleStepperUI(removeSimpleBtn.dataset.removeSimple, 0);
    } else if (incSimpleBtn) {
      var key = incSimpleBtn.dataset.incSimple;
      if (this.state.extraSimple[key]) {
        this.state.extraSimple[key].qty += 1;
        this.syncExtraSimpleStepperUI(key, this.state.extraSimple[key].qty);
      }
    } else if (decSimpleBtn) {
      var key2 = decSimpleBtn.dataset.decSimple;
      if (this.state.extraSimple[key2] && this.state.extraSimple[key2].qty > 0) {
        this.state.extraSimple[key2].qty -= 1;
        this.syncExtraSimpleStepperUI(key2, this.state.extraSimple[key2].qty);
      }
    } else if (removeFlavorBtn) {
      var group = removeFlavorBtn.dataset.flavorGroup;
      var name = removeFlavorBtn.dataset.flavorName;
      var target = removeFlavorBtn.dataset.removeFlavor;

      if (target === 'soup') delete this.state.soupSelections[name];
      if (target === 'sauce') delete this.state.sauceSelections[name];
      if (target === 'extraSoup') delete this.state.extraSoupSelections[name];
      if (target === 'extraSauce') delete this.state.extraSauceSelections[name];

      this.syncFlavorStepperUI(target, name, 0);
    } else {
      return;
    }

    this.renderSummary();
    this.updateSummary();
  };

  HotpotConfigurator.prototype.syncExtraSimpleStepperUI = function (key, qty) {
    var stepperEl = this.root.querySelector('[data-hotpot-extra-stepper][data-extra-key="' + key + '"]');
    if (!stepperEl) return;
    var countEl = stepperEl.querySelector('[data-hotpot-extra-count]');
    if (countEl) countEl.textContent = String(qty);
    stepperEl.classList.toggle('has-selection', qty > 0);
  };

  HotpotConfigurator.prototype.syncFlavorStepperUI = function (target, name, qty) {
    var sourceSelector;
    if (target === 'soup' || target === 'sauce') {
      sourceSelector = '[data-hotpot-flavor-stepper][data-flavor-group="' + target + '"][data-flavor-name="' + name + '"]';
    } else {
      var group = target === 'extraSoup' ? 'soup' : 'sauce';
      sourceSelector = '[data-hotpot-extra-flavor-stepper][data-extra-group="' + group + '"][data-flavor-name="' + name + '"]';
    }
    var stepperEl = this.root.querySelector(sourceSelector);
    if (!stepperEl) return;

    var countEl = stepperEl.querySelector('[data-hotpot-flavor-count], [data-hotpot-extra-flavor-count]');
    if (countEl) countEl.textContent = String(qty);
    stepperEl.classList.toggle('has-selection', qty > 0);

    if (target === 'soup' || target === 'sauce') {
      this.updateFlavorGroupCounter(target);
    }
  };

  /* --- Prijsberekening --- */

  HotpotConfigurator.prototype.configHasExtras = function (config) {
    var simpleQty = Object.keys(config.extraSimple).reduce(function (sum, key) {
      return sum + (config.extraSimple[key].qty || 0);
    }, 0);
    var soupQty = this.sumSelections(config.extraSoupSelections);
    var sauceQty = this.sumSelections(config.extraSauceSelections);
    return simpleQty > 0 || soupQty > 0 || sauceQty > 0;
  };

    HotpotConfigurator.prototype.getExtraFlavorMeta = function (group) {
    var groupEl = this.root.querySelector('[data-hotpot-extra-flavor-group="' + group + '"]');
    if (!groupEl) return null;

    var variantsByName = {};
    try {
      var variants = JSON.parse(groupEl.dataset.variants || '[]');
      variants.forEach(function (v) {
        var key = String(v.title || '').trim().toLowerCase();
        variantsByName[key] = {
          variantId: v.id,
          priceCents: v.price,
          comparePriceCents: v.compare_at_price || 0
        };
      });
    } catch (e) {}

    return {
      variantId: groupEl.dataset.variantId,
      priceCents: parseInt(groupEl.dataset.priceCents, 10) || 0,
      comparePriceCents: parseInt(groupEl.dataset.compareCents, 10) || parseInt(groupEl.dataset.comparePriceCents, 10) || 0,
      variantsByName: variantsByName
    };
  };

  /* Zoekt de Shopify-variant die bij een gekozen smaak hoort. Valt terug op
     de standaardvariant als de naam niet exact overeenkomt — met een
     waarschuwing in de console, zodat een mismatch (bijv. typefout in de
     smaak-naam t.o.v. de Shopify-varianttitel) meteen opvalt bij het testen. */
  HotpotConfigurator.prototype.findFlavorVariant = function (meta, flavorName) {
    if (!meta) return null;
    var key = String(flavorName || '').trim().toLowerCase();
    var match = meta.variantsByName[key];
    if (match) return match;

    console.warn('Hotpot: geen Shopify-variant gevonden voor smaak "' + flavorName + '" — gebruik standaardvariant. Check of de naam exact overeenkomt met de varianttitel in Shopify.');
    return { variantId: meta.variantId, priceCents: meta.priceCents, comparePriceCents: meta.comparePriceCents };
  };

    HotpotConfigurator.prototype.computeConfigTotals = function (config) {
    var self = this;
    var actual = config.priceCents;
    var compareBase = config.comparePriceCents > config.priceCents ? config.comparePriceCents : config.priceCents;
    var compare = compareBase;

    Object.keys(config.extraSimple).forEach(function (key) {
      var extra = config.extraSimple[key];
      actual += extra.qty * extra.priceCents;
      var unit = extra.comparePriceCents > extra.priceCents ? extra.comparePriceCents : extra.priceCents;
      compare += extra.qty * unit;
    });

    var soupMeta = this.getExtraFlavorMeta('soup');
    if (soupMeta) {
      Object.keys(config.extraSoupSelections).forEach(function (name) {
        var qty = config.extraSoupSelections[name];
        if (qty <= 0) return;
        var variant = self.findFlavorVariant(soupMeta, name);
        actual += qty * variant.priceCents;
        var unit = variant.comparePriceCents > variant.priceCents ? variant.comparePriceCents : variant.priceCents;
        compare += qty * unit;
      });
    }

    var sauceMeta = this.getExtraFlavorMeta('sauce');
    if (sauceMeta) {
      Object.keys(config.extraSauceSelections).forEach(function (name) {
        var qty = config.extraSauceSelections[name];
        if (qty <= 0) return;
        var variant = self.findFlavorVariant(sauceMeta, name);
        actual += qty * variant.priceCents;
        var unit = variant.comparePriceCents > variant.priceCents ? variant.comparePriceCents : variant.priceCents;
        compare += qty * unit;
      });
    }

    return { actual: actual, compare: compare };
  };

  HotpotConfigurator.prototype.calculateGrandTotals = function () {
    var self = this;
    var actualTotal = 0;
    var compareTotal = 0;

    this.completedConfigs.forEach(function (config) {
      var totals = self.computeConfigTotals(config);
      actualTotal += totals.actual;
      compareTotal += totals.compare;
    });

    if (this.state.baseVariantId || this.configHasExtras(this.state)) {
      var currentTotals = this.computeConfigTotals(this.state);
      actualTotal += currentTotals.actual;
      compareTotal += currentTotals.compare;
    }

    return { actual: actualTotal, compare: compareTotal };
  };

  /* --- Samenvatting renderen --- */

  HotpotConfigurator.prototype.formatSelections = function (selections) {
    return Object.keys(selections)
      .filter(function (name) { return selections[name] > 0; })
      .map(function (name) { return selections[name] + 'x ' + name; })
      .join(', ');
  };

  HotpotConfigurator.prototype.buildIncludedItemsHtml = function (config) {
    if (!config.baseVariantId) return '';

    var personButton = this.root.querySelector('[data-hotpot-select-persons][data-variant-id="' + config.baseVariantId + '"]');
    if (!personButton) return '';

    var includedRaw = personButton.dataset.includedItems;
    if (!includedRaw) return '';

    var lines = includedRaw.split('|').filter(function (line) { return line.trim() !== ''; });
    if (lines.length === 0) return '';

    return '<p class="hotpot-summary-card__box-included">' + lines.join(', ') + '</p>';
  };

  HotpotConfigurator.prototype.buildChosenCompositionHtml = function (config, editButtonHtml) {
    var s = this.strings.step5;
    var soupText = this.formatSelections(config.soupSelections);
    var sauceText = this.formatSelections(config.sauceSelections);

    if (!soupText && !sauceText && !config.plateColor && !config.bookFormat) return '';

    var html = '<div class="hotpot-summary-card__section-title">' + s.chosenComposition + (editButtonHtml || '') + '</div>';
    if (soupText) html += '<div class="hotpot-summary-card__row"><span class="hotpot-summary-card__row-label">' + s.soupBase + '</span><span class="hotpot-summary-card__row-value">' + soupText + '</span></div>';
    if (sauceText) html += '<div class="hotpot-summary-card__row"><span class="hotpot-summary-card__row-label">' + s.dipSauce + '</span><span class="hotpot-summary-card__row-value">' + sauceText + '</span></div>';
    if (config.plateColor) html += '<div class="hotpot-summary-card__row"><span class="hotpot-summary-card__row-label">' + s.plateColorLabel + '</span><span class="hotpot-summary-card__row-value">' + config.plateColor + '</span></div>';
    if (config.bookFormat) html += '<div class="hotpot-summary-card__row"><span class="hotpot-summary-card__row-label">' + s.bookLabel + '</span><span class="hotpot-summary-card__row-value">' + config.bookFormat + '</span></div>';
    return html;
  };

  HotpotConfigurator.prototype.buildExtraLinesHtml = function (config) {
    var self = this;
    var s = this.strings.step5;
    var lines = [];

    Object.keys(config.extraSimple).forEach(function (key) {
      var extra = config.extraSimple[key];
      if (extra.qty > 0) lines.push(extra.qty + 'x ' + extra.label);
    });

    var extraSoupText = this.formatSelections(config.extraSoupSelections);
    if (extraSoupText) lines.push(extraSoupText + ' (' + s.extraSoupLabel + ')');

    var extraSauceText = this.formatSelections(config.extraSauceSelections);
    if (extraSauceText) lines.push(extraSauceText + ' (' + s.extraSauceLabel + ')');

    if (lines.length === 0) return '';

    return (
      '<div class="hotpot-summary-card__section-title hotpot-summary-card__section-title--divider">' + s.extraAdditions + '</div>' +
      '<div class="hotpot-summary-card__row"><span class="hotpot-summary-card__row-value">' + lines.join(', ') + '</span></div>'
    );
  };

  /* Kaart voor een AFGERONDE, al toegevoegde Experience — puur weergave,
     geen bewerkbare +/- knoppen. BUGFIX: bouwde voorheen geen rows meer op. */
  HotpotConfigurator.prototype.buildConfigCardHtml = function (config, label, removeIndex, editIndex) {
    var s = this.strings.step5;
    var totals = this.computeConfigTotals(config);
    var rows = '';

    var boxLabel = config.persons ? config.persons : (config.baseVariantId ? s.boxStandalone : s.boxNoBox);
    rows += '<div class="hotpot-summary-card__row"><span class="hotpot-summary-card__row-label">' + s.box + '</span><span class="hotpot-summary-card__row-value">' + boxLabel + '</span></div>';
    rows += this.buildIncludedItemsHtml(config);
    rows += this.buildChosenCompositionHtml(config, '');
    rows += this.buildExtraLinesHtml(config);

    var editButtonHtml = typeof editIndex === 'number'
      ? '<button type="button" class="hotpot-summary-card__edit" data-edit-config="' + editIndex + '">' + s.edit + '</button>'
      : '';

    var removeButtonHtml = typeof removeIndex === 'number'
      ? '<button type="button" class="hotpot-summary-card__remove" data-remove-config="' + removeIndex + '" aria-label="' + s.removeAria + '">&times;</button>'
      : '';

    var compareHtml = totals.compare > totals.actual
      ? '<span class="hotpot-price-compare">' + this.formatMoney(totals.compare) + '</span>'
      : '';

    return (
      '<div class="hotpot-summary-card">' +
        editButtonHtml +
        removeButtonHtml +
        '<p class="hotpot-summary-card__title">' + label + '</p>' +
        rows +
        '<div class="hotpot-summary-card__subtotal">' +
          '<span>' + s.subtotal + '</span>' +
          '<span>' + compareHtml + '<span class="hotpot-price-actual">' + this.formatMoney(totals.actual) + '</span></span>' +
        '</div>' +
      '</div>'
    );
  };

  /* Kaart voor de HUIDIGE (nog niet toegevoegde) configuratie — mét
     bewerkbare +/- knoppen per extra en verwijder-kruisjes per smaak. */
  HotpotConfigurator.prototype.buildEditableCurrentCardHtml = function (config, label) {
    var self = this;
    var s = this.strings.step5;
    var totals = this.computeConfigTotals(config);
    var rows = '';

    var boxLabel = config.persons ? config.persons : (config.baseVariantId ? s.boxStandalone : s.boxNoBox);
    rows +=
      '<div class="hotpot-summary-card__row">' +
        '<span class="hotpot-summary-card__row-label">' + s.box + '</span>' +
        '<span class="hotpot-summary-card__row-value">' + boxLabel +
          ' <button type="button" class="hotpot-summary-card__edit" data-edit-current-box>' + s.edit + '</button>' +
        '</span>' +
      '</div>';

    rows += this.buildIncludedItemsHtml(config);

    var editFlavorsBtnHtml = '<button type="button" class="hotpot-summary-card__edit hotpot-summary-card__edit--inline" data-edit-flavors>' + s.edit + '</button>';
    rows += this.buildChosenCompositionHtml(config, editFlavorsBtnHtml);

    var hasExtraItems = this.configHasExtras(config);
    if (hasExtraItems) {
      rows += '<div class="hotpot-summary-card__section-title hotpot-summary-card__section-title--divider">' + s.extraAdditions + '</div>';
    }

    Object.keys(config.extraSimple).forEach(function (key) {
      var extra = config.extraSimple[key];
      if (extra.qty > 0) {
        rows +=
          '<div class="hotpot-summary-line">' +
            '<span class="hotpot-summary-line__label">' + extra.label + ' (' + self.formatMoney(extra.priceCents) + ' ' + s.perUnit + ')</span>' +
            '<div class="hotpot-summary-line__controls">' +
              '<button type="button" class="hotpot-summary-line__qty-button" data-dec-simple="' + key + '" aria-label="' + s.removeAria + '">&minus;</button>' +
              '<span>' + extra.qty + '</span>' +
              '<button type="button" class="hotpot-summary-line__qty-button" data-inc-simple="' + key + '" aria-label="+">+</button>' +
              '<button type="button" class="hotpot-summary-line__remove" data-remove-simple="' + key + '" aria-label="' + s.removeAria + '">&times;</button>' +
            '</div>' +
          '</div>';
      }
    });

    ['extraSoup', 'extraSauce'].forEach(function (target) {
      var selections = target === 'extraSoup' ? config.extraSoupSelections : config.extraSauceSelections;
      var flavorGroup = target === 'extraSoup' ? 'soup' : 'sauce';
      var groupLabel = target === 'extraSoup' ? s.extraSoupLabel : s.extraSauceLabel;
      Object.keys(selections).forEach(function (name) {
        if (selections[name] > 0) {
          rows +=
            '<div class="hotpot-summary-line">' +
              '<span class="hotpot-summary-line__label">' + groupLabel + ': ' + selections[name] + 'x ' + name + '</span>' +
              '<div class="hotpot-summary-line__controls">' +
                '<button type="button" class="hotpot-summary-line__remove" data-remove-flavor="' + target + '" data-flavor-group="' + flavorGroup + '" data-flavor-name="' + name + '" aria-label="' + s.removeAria + '">&times;</button>' +
              '</div>' +
            '</div>';
        }
      });
    });

    var compareHtml = totals.compare > totals.actual
      ? '<span class="hotpot-price-compare">' + this.formatMoney(totals.compare) + '</span>'
      : '';

    return (
      '<div class="hotpot-summary-card hotpot-summary-card--current">' +
        '<p class="hotpot-summary-card__title">' + label + '</p>' +
        rows +
        '<div class="hotpot-summary-card__subtotal">' +
          '<span>' + s.subtotal + '</span>' +
          '<span>' + compareHtml + '<span class="hotpot-price-actual">' + this.formatMoney(totals.actual) + '</span></span>' +
        '</div>' +
      '</div>'
    );
  };

  HotpotConfigurator.prototype.renderSummary = function () {
    var self = this;
    var s = this.strings.step5;
    var productTitle = this.data.productTitle || s.productTitleFallback;

    if (this.summaryListEl) {
      var listHtml = this.completedConfigs.map(function (config, index) {
        var numberLabel = productTitle + ' — ' + s.experienceNumber.replace('{{ number }}', index + 1);
        return self.buildConfigCardHtml(config, numberLabel, index, index);
      }).join('');
      this.summaryListEl.innerHTML = listHtml;
    }

    if (this.summaryCurrentEl) {
      if (this.state.baseVariantId || this.configHasExtras(this.state)) {
        var currentLabel = productTitle + ' — ' + s.experienceNumber.replace('{{ number }}', this.completedConfigs.length + 1) + s.currentSuffix;
        this.summaryCurrentEl.innerHTML = this.buildEditableCurrentCardHtml(this.state, currentLabel);
      } else {
        this.summaryCurrentEl.innerHTML = '';
      }
    }

    var grandTotals = this.calculateGrandTotals();
    if (this.grandTotalEl) this.grandTotalEl.textContent = this.formatMoney(grandTotals.actual);
    if (this.grandCompareEl) {
      if (grandTotals.compare > grandTotals.actual) {
        this.grandCompareEl.textContent = this.formatMoney(grandTotals.compare);
        this.grandCompareEl.hidden = false;
      } else {
        this.grandCompareEl.hidden = true;
      }
    }
  };

  HotpotConfigurator.prototype.updateSummary = function () {
    var grandTotals = this.calculateGrandTotals();

    if (this.totalPriceEl) this.totalPriceEl.textContent = this.formatMoney(grandTotals.actual);
    if (this.comparePriceEl) {
      if (grandTotals.compare > grandTotals.actual) {
        this.comparePriceEl.textContent = this.formatMoney(grandTotals.compare);
        this.comparePriceEl.hidden = false;
      } else {
        this.comparePriceEl.hidden = true;
      }
    }

    if (this.summaryBar) {
      this.summaryBar.hidden = false;
      this.summaryBar.classList.add('is-visible');
    }

    var hasAnything = !!this.state.baseVariantId || this.configHasExtras(this.state) || this.completedConfigs.length > 0;

    if (this.addButton) this.addButton.disabled = !hasAnything;
    if (this.checkoutButton) this.checkoutButton.disabled = !hasAnything;

    if (this.summaryStep && !this.summaryStep.hidden) this.renderSummary();

    this.saveStateToStorage();
  };

  HotpotConfigurator.prototype.formatMoney = function (cents) {
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return '€ ' + euros;
  };

  /* --- Progress bar --- */

  HotpotConfigurator.prototype.setProgress = function (stepIndex, markComplete) {
    this.lastProgressStep = stepIndex;
    this.lastProgressComplete = markComplete;

    if (!this.progressSteps || !this.progressSteps.length) return;

    this.progressSteps.forEach(function (stepEl) {
      var index = parseInt(stepEl.dataset.hotpotProgressStep, 10);
      stepEl.classList.remove('is-active', 'is-complete', 'is-locked');

      if (index < stepIndex || (index === stepIndex && markComplete)) {
        stepEl.classList.add('is-complete');
      } else if (index === stepIndex + 1) {
        stepEl.classList.add('is-active');
      } else if (index > stepIndex + 1) {
        stepEl.classList.add('is-locked');
      } else {
        stepEl.classList.add('is-active');
      }
    });

    if (this.progressFill) {
      var completedSteps = markComplete ? stepIndex : stepIndex - 1;
      var percentage = (completedSteps / (TOTAL_STEPS - 1)) * 100;
      this.progressFill.style.width = Math.min(percentage, 100) + '%';
    }
  };

  /* --- Winkelwagen-badge --- */

  HotpotConfigurator.prototype.updateCartBadge = function () {
    var self = this;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (self.cartBadgeEl) {
          if (cart.item_count > 0) {
            self.cartBadgeEl.textContent = cart.item_count;
            self.cartBadgeEl.hidden = false;
          } else {
            self.cartBadgeEl.hidden = true;
          }
        }
        if (self.cartTotalPriceEl) {
          self.cartTotalPriceEl.textContent = self.formatMoney(cart.total_price);
        }
      })
      .catch(function () {});
  };

  /* --- Voortgang bewaren in sessionStorage --- */

  HotpotConfigurator.prototype.getStorageKey = function () {
    return 'hotpotConfiguratorState:' + this.sectionId;
  };

  HotpotConfigurator.prototype.saveStateToStorage = function () {
    try {
      var payload = {
        completedConfigs: this.completedConfigs,
        state: this.state,
        ui: {
          personsHidden: this.personsStep ? this.personsStep.hidden : true,
          flavorsHidden: this.flavorsStep ? this.flavorsStep.hidden : true,
          extrasHidden: this.extrasStep ? this.extrasStep.hidden : true,
          summaryHidden: this.summaryStep ? this.summaryStep.hidden : true,
          progressStep: this.lastProgressStep || 0,
          progressComplete: !!this.lastProgressComplete
        }
      };
      sessionStorage.setItem(this.getStorageKey(), JSON.stringify(payload));
    } catch (e) {}
  };

  HotpotConfigurator.prototype.clearStorageState = function () {
    try {
      sessionStorage.removeItem(this.getStorageKey());
    } catch (e) {}
  };

  HotpotConfigurator.prototype.loadStateFromStorage = function () {
    var raw;
    try {
      raw = sessionStorage.getItem(this.getStorageKey());
    } catch (e) {
      raw = null;
    }
    if (!raw) return;

    var payload;
    try {
      payload = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!payload || !payload.state) return;

    this.completedConfigs = payload.completedConfigs || [];
    this.state = payload.state;

    if (this.personsStep) this.personsStep.hidden = !!payload.ui.personsHidden;
    if (this.flavorsStep) this.flavorsStep.hidden = !!payload.ui.flavorsHidden;
    if (this.extrasStep) this.extrasStep.hidden = !!payload.ui.extrasHidden;
    if (this.summaryStep) this.summaryStep.hidden = !!payload.ui.summaryHidden;

    if (!payload.ui.personsHidden && this.state.baseVariantId) {
      // Bij herstel weten we niet zeker welk kader was geselecteerd zonder
      // extra data op te slaan — dat is geen probleem, want de klant ziet
      // sowieso meteen aan Stap 2 dat de keuze al is gemaakt.
    }

    if (this.state.baseVariantId) {
      var personButton = this.root.querySelector('[data-hotpot-select-persons][data-variant-id="' + this.state.baseVariantId + '"]');
      if (personButton) {
        var soupGroupEl = this.root.querySelector('[data-hotpot-flavor-group="soup"]');
        var sauceGroupEl = this.root.querySelector('[data-hotpot-flavor-group="sauce"]');
        if (soupGroupEl) soupGroupEl.dataset.requiredCount = personButton.dataset.soupCount || 0;
        if (sauceGroupEl) sauceGroupEl.dataset.requiredCount = personButton.dataset.sauceCount || 0;
      }
    }

    this.restoreStateToUI();
    this.updateFlavorGroupCounter('soup');
    this.updateFlavorGroupCounter('sauce');

    this.renderSummary();
    this.updateSummary();

    this.setProgress(payload.ui.progressStep || 0, payload.ui.progressComplete);
  };

  /* --- Winkelwagen --- */

    HotpotConfigurator.prototype.buildCartItemsForConfig = function (config) {
    var self = this;
    var items = [];

    if (config.baseVariantId) {
      var properties = {};
      if (config.persons) properties['Personen'] = config.persons;

      var soupText = this.formatSelections(config.soupSelections);
      if (soupText) properties['Soepbasis'] = soupText;

      var sauceText = this.formatSelections(config.sauceSelections);
      if (sauceText) properties['Dipsaus'] = sauceText;

      if (config.plateColor) properties['Schaaltjeskleur'] = config.plateColor;
      if (config.bookFormat) properties['Boekformaat'] = config.bookFormat;

      items.push({ id: config.baseVariantId, quantity: 1, properties: properties });
    }

    Object.keys(config.extraSimple).forEach(function (key) {
      var extra = config.extraSimple[key];
      if (extra.qty > 0) {
        items.push({ id: key, quantity: extra.qty });
      }
    });

    var soupMeta = this.getExtraFlavorMeta('soup');
    if (soupMeta) {
      Object.keys(config.extraSoupSelections).forEach(function (name) {
        var qty = config.extraSoupSelections[name];
        if (qty <= 0) return;
        var variant = self.findFlavorVariant(soupMeta, name);
        items.push({ id: variant.variantId, quantity: qty });
      });
    }

    var sauceMeta = this.getExtraFlavorMeta('sauce');
    if (sauceMeta) {
      Object.keys(config.extraSauceSelections).forEach(function (name) {
        var qty = config.extraSauceSelections[name];
        if (qty <= 0) return;
        var variant = self.findFlavorVariant(sauceMeta, name);
        items.push({ id: variant.variantId, quantity: qty });
      });
    }

    return items.filter(function (item) {
      return item.id !== null && item.id !== undefined && item.id !== '' && item.quantity > 0;
    });
  };

  HotpotConfigurator.prototype.addToCart = function (redirectToCheckout) {
    var self = this;
    var s = this.strings.summaryBar;

    var allConfigs = this.completedConfigs.slice();
    if (this.state.baseVariantId || this.configHasExtras(this.state)) {
      allConfigs.push(this.state);
    }

    if (allConfigs.length === 0) return;

    var triggerButton = redirectToCheckout ? this.checkoutButton : this.addButton;

    if (this.addButton) this.addButton.disabled = true;
    if (this.checkoutButton) this.checkoutButton.disabled = true;
    if (triggerButton) triggerButton.textContent = redirectToCheckout ? s.redirecting : s.adding;

    var items = [];
    allConfigs.forEach(function (config) {
      items = items.concat(self.buildCartItemsForConfig(config));
    });

    if (items.length === 0) {
      if (triggerButton) triggerButton.textContent = s.selectFirst;
      if (this.addButton) this.addButton.disabled = false;
      if (this.checkoutButton) this.checkoutButton.disabled = false;
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            var message = (data && data.description) ? data.description : s.failed;
            throw new Error(message);
          }
          return data;
        });
      })
      .then(function () {
        if (redirectToCheckout) {
          window.location.href = '/checkout';
          return;
        }

        self.updateCartBadge();
        self.softResetSelection();

        if (self.addButton) {
          self.addButton.textContent = s.added;
          setTimeout(function () {
            self.addButton.textContent = s.addToCart;
          }, 2500);
        }
        if (self.checkoutButton) self.checkoutButton.disabled = false;
      })
      .catch(function (error) {
        console.error('Hotpot cart error:', error);
        if (triggerButton) {
          triggerButton.textContent = error.message ? error.message : s.failed;
        }
        if (self.addButton) self.addButton.disabled = false;
        if (self.checkoutButton) self.checkoutButton.disabled = false;
      });
  };
})();